export default __webpack_public_path__ + "static/media/ampl.d02bddcc.svg";